import { Spin } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { ArrowLeft } from '../../assets/icons';
import AccountNav from '../../components/AccountNav/AccountNav';
import AccountNavMobile from '../../components/AccountNavMobile/AccountNavMobile';
import AccountSidebar from '../../components/AccountSidebar/AccountSidebar';
import MarketFooter from '../../components/MarketFooter/MarketFooter';
import SidebarMobile from '../../components/SidebarMobile/SidebarMobile';
import WarningBar from '../../components/WarningBar/WarningBar';
import './Account.scss';

const Account = () => {
  const [loading, setLoading] = useState(false);
  const [sideBarName, setSideBarName] = useState('Profile');
  const [isSidebarVisible, setSidebarVisible] = useState(true);
  const userData = useSelector((state) => state.userData);
  let navigate = useNavigate();
  return (
    <div className='account'>
      <div className='sticky-nav'>
        <AccountNav />
      </div>
      <AccountNavMobile setSideBarName={setSideBarName} />
      <Spin spinning={loading} wrapperClassName={loading && 'ant-spin--fullscreen'} className={loading && 'ant-spin--fullscreen'}>
        <SidebarMobile setPopPage={setSideBarName} popPage={sideBarName} />
        {userData?.userData?.citizenshipStatus !== 'Non US Resident' && !userData?.userData?.isKYCVerified && (
          <WarningBar action={() => navigate(`/sign-up/verification`)} />
        )}
        <div className='account__body'>
          {isSidebarVisible ? (
            <AccountSidebar />
          ) : (
            <div className='return-link'>
              <Link to='/account/legal' replace onClick={() => setSidebarVisible(true)} className='text-copper fw-600 cursor-pointer mb-32'>
                <ArrowLeft verticalAlign='-6px' /> Return to Account
              </Link>
            </div>
          )}
          <Outlet context={{ setLoading, setSidebarVisible }} />
        </div>
        <MarketFooter />
      </Spin>
    </div>
  );
};

export default Account;
